import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	role: '',
	first_name: '',
	last_name: '',
	avatar_url: '',
	status: '',
	life_cycle: '',
	tour_done: '',
	email: '',
	email_verified: '',
	hammurabi_preferences: {
		shortcuts: [],
		theme: 'light',
		notifications: {},
	},
	last_login: '',
	auth_id: '',
};

const userSlice = createSlice({
	name: 'auth/user',
	initialState,
	reducers: {
		setUser: (state, action) => action.payload,
	},
});

export const { setUser, userLoggedOut } = userSlice.actions;

export default userSlice.reducer;
